export default __webpack_public_path__ + "static/media/dominospizza.3619c97f.png";